import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Customer.css';

const ClaimSubmission: React.FC = () => {
  const { warrantyId } = useParams<{ warrantyId: string }>();
  const [productImage, setProductImage] = useState<File | null>(null);
  const [upiQR, setUpiQR] = useState<File | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!productImage) {
      setError('Product image is required');
      return;
    }

    if (!upiQR) {
      setError('UPI QR code image is required');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('warrantyId', warrantyId || '');
    formData.append('productImage', productImage);
    formData.append('upiQR', upiQR);

    try {
      const response = await axios.post('/api/claim/submit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setSuccess(true);
      setTimeout(() => {
        navigate('/customer/dashboard');
      }, 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to submit claim');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <>
        <Navbar />
        <div className="container">
          <div className="card" style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
            <h2 style={{ color: '#4caf50', marginBottom: '20px' }}>Claim Submitted Successfully!</h2>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              Your claim has been received and is being processed.
            </p>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
              <strong>You will receive your payment within 15 minutes.</strong>
            </p>
            <p style={{ fontSize: '14px', color: '#999' }}>
              Redirecting to dashboard...
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container">
        <h1 className="page-title">📋 Submit Claim</h1>
        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Product Image * <span style={{ color: 'red', fontWeight: 'bold' }}>(Upload back side of screen)</span></label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setProductImage(e.target.files?.[0] || null)}
                required
              />
            </div>
            <div className="form-group">
              <label>UPI QR Code Image *</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setUpiQR(e.target.files?.[0] || null)}
                required
              />
              <small>Upload your UPI QR code image for payment</small>
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Claim'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ClaimSubmission;

